import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga';
import { UPLOAD_FILE_REQUEST, UPLOAD_MEDIA_REQUEST } from './actions/actionTypes';

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [UPLOAD_MEDIA_REQUEST, UPLOAD_FILE_REQUEST],
    }
  }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;